import React from 'react';
import PropTypes from 'prop-types';
import {FormLayout, FormLayoutDirection} from '@yandex-data-ui/cloud-components';

import withMobile from 'hoc/withMobile';

class FormLayoutRowProxy extends React.Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        ...FormLayout.Row.propTypes,
    };

    render() {
        const {isMobile, direction, ...formRowProps} = this.props;
        const rowDirection = isMobile ? FormLayoutDirection.Column : direction;

        return <FormLayout.Row {...formRowProps} direction={rowDirection} />;
    }
}

export default class FormLayoutProxy extends React.Component {
    static propTypes = FormLayout.propTypes;
    static Row = withMobile(FormLayoutRowProxy);
    static Search = FormLayout.Search;

    render() {
        return <FormLayout {...this.props} />;
    }
}
